(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PDFFormFiller", [], factory);
	else if(typeof exports === 'object')
		exports["PDFFormFiller"] = factory();
	else
		root["PDFFormFiller"] = factory();
})(this, () => {
return 